export const state = () => ({
  settings: {
    style: 'material_design',
    cell_height: 50,
    view_type: 'schedule',
    scrollToNow: true,
    scrollToNewEvent: false,
    start_day: new Date().toISOString(),
    read_only: false,
    day_starts_at: 0,
    day_ends_at: 24,
    overlap: false,
    hide_days: [],
    past_event_creation: true,
    is_custom_time_label_interval: true,
    time_label_interval: 10 // minutes
  },
  navigator: {
    weekPosition: 0,
    dayPosition: 0,
    start: null,
    end: null
  },
  filterList: {
    key: [],
    data: []
  },
  currentSchedule: null,
  fixedOverlapArr: [],
  overlaps: false,
  errorTenMinutes: false,
  showModalRequestSchedule: false,
  modalRequestData: null,
  modalRequestActiveTab: '',
  modalNoScheduleFirstTimeAppear: false,
  cellEvent: null,
  eventsLoaded: false,
  events: [],
  highlightedEvent: null,
  glossaries: {
    doctorEmployeeType: {
      partner: 'PARTNER',
      independent: 'SELF',
      employee: 'EMPLOYEE'
    },
    scheduleType: {
      online: 'Online',
      onsite: 'OnSite',
      offline: 'NonOnline',
      exercise: 'Exercise'
    }
  },
  appointmentPriceList: [],
  appointmentLengthList: [],
  facilityList: [],
  autoRefreshStatuses: [
    'MITRA_CREATE_SCHEDULE',
    'CLINIC_REQUEST_SCHEDULE',
    'CLINIC_DELETE_SCHEDULE',
    'CLINIC_CREATE_FULLTIME_SCHEDULE',
    'CLINIC_APPROVED_SCHEDULED'
  ],
  hasNewNotification: false
})

export const mutations = {
  CHANGE_SETTING: (state, data) => {
    const { key, value } = data

    state.settings[key] = value
  },

  NAVIGATE: (state, data) => {
    const { key, value } = data
    state.navigator[key] = value
  },

  SET_CURRENT_SCHEDULE: (state, value) => {
    state.currentSchedule = value
  },

  SET_HIGHLIGHT_EVENT: (state, value) => {
    state.highlightedEvent = value
  },

  SET_EVENTS: (state, value) => {
    state.events = value
  },

  RESET_FILTER_KEY: (state) => {
    state.filterList.key = []
  },

  RESET_FILTER_DATA: (state) => {
    state.filterList.data = []
  },

  SET_FILTER_KEY: (state, value) => {
    state.filterList.key.push(value)
  },

  SET_FILTER_DATA: (state, value) => {
    state.filterList.data.push(value)
  },

  SET_OVERLAPS: (state, value) => {
    state.overlaps = value
  },

  SET_TEN_MINUTES: (state, value) => {
    state.errorTenMinutes = value
  },

  PUSH_OVERLAPS_ARRAY: (state, value) => {
    if (value !== null) {
      state.fixedOverlapArr.push(value)
    } else {
      state.fixedOverlapArr = []
    }
  },

  SET_SCROLL_TO_NEW_EVENT: (state, value) => {
    state.scrollToNewEvent = value
  },

  SET_CELL_EVENT: (state, value) => {
    state.cellEvent = value
  },

  SET_SHOW_MODAL_REQUEST_SCHEDULE: (state, value) => {
    state.showModalRequestSchedule = value
  },

  SET_MODAL_NO_SCHEDULE_DATA: (state, value) => {
    state.modalNoScheduleFirstTimeAppear = value
  },

  SET_MODAL_REQUEST_DATA: (state, value) => {
    state.modalRequestData = value
  },

  SET_MODAL_REQUEST_ACTIVE_TAB: (state, value) => {
    state.modalRequestActiveTab = value
  },

  SET_APPOINTMENT_PRICE_LIST: (state, value) => {
    state.appointmentPriceList = value
  },

  SET_APPOINTMENT_LENGTH_LIST: (state, value) => {
    state.appointmentLengthList = value
  },

  SET_FACILITY_LIST: (state, value) => {
    state.facilityList = value
  },

  SET_HAS_NEW_NOTIFICATION: (state, value) => {
    state.hasNewNotification = value
  },

  SET_EVENTS_LOADED: (state, value) => {
    state.eventsLoaded = value
  }
}

export const actions = {
  updateScheduleNotifications () {
    return new Promise((resolve, reject) => {
      this.$api.put('doctor/contract/notifications')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getScheduleNotifications () {
    return new Promise((resolve, reject) => {
      this.$api.get('doctor/contract/notifications')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getScheduleBooked ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$api.get('doctor/calendars/facilities')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getEventsByDateRange ({ rootState, dispatch }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      const { start, end, query } = data

      if (query && typeof query !== 'undefined' && query.length) { formData.append('Query', query) }

      this.$api.post(rootState.user.auth.role_endpoint + 'calendars/' + start + '/' + end, formData)
        .then(function (response) {
          const res = response.data

          dispatch('getEventsFilterListByDateRange', {
            start,
            end
          })

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getEventsFilterListByDateRange ({ commit, rootState }, data) {
    return new Promise((resolve, reject) => {
      const { start, end } = data

      commit('RESET_FILTER_KEY')
      commit('RESET_FILTER_DATA')

      this.$api.get(rootState.user.auth.role_endpoint + 'calendars/filter/' + start + '/' + end)
        .then(function (response) {
          const res = response.data

          Object.keys(res.Data).forEach((k) => {
            const key = k
            let keyTranslated = ''

            if (key === 'AVAILABLE') { keyTranslated = 'Tersedia' } else if (key === 'SCHEDULED') { keyTranslated = 'Terjadwal' } else if (key === 'DONE') { keyTranslated = 'Done' } else if (key === 'DOCTOR_CANCEL') { keyTranslated = 'Gagal Dokter' } else if (key === 'DOCTOR_END_CALL') { keyTranslated = 'Panggilan Diakhiri Dokter' } else if (key === 'DOCTOR_NO_ANSWER') { keyTranslated = 'Dokter Tidak Memanggil' } else if (key === 'PATIENT_CANCEL') { keyTranslated = 'Gagal Pasien' } else if (key === 'PATIENT_ACCIDENT') { keyTranslated = 'Kesalahan Pasien' } else if (key === 'PATIENT_NO_ANSWER') { keyTranslated = 'Pasien Tidak Hadir' } else if (key === 'PATIENT_REJECT') { keyTranslated = 'Pasien Menolak Panggilan' } else if (key === 'PATIENT_END_CALL') { keyTranslated = 'Pasien Mengakhiri Panggilan' } else if (key === 'TIME_OUT') { keyTranslated = 'Panggilan Diakhiri Waktu' } else if (key === 'BOTH_NO_ANSWER') { keyTranslated = 'Keduanya Tidak Menjawab' } else if (key === 'DOCTOR_ACCIDENT') { keyTranslated = 'Kesalahan Dokter' } else if (key === 'PATIENT_MISSED_CALL') { keyTranslated = 'Pasien Tidak Menjawab' } else if (key === 'UNFINISHED_SUMMARY') { keyTranslated = 'Dokter Tidak Mengisi Summary' } else { keyTranslated = key }

            commit('SET_FILTER_KEY', {
              key,
              keyTranslated
            })
            commit('SET_FILTER_DATA', res.Data[k])
          })

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getLocations ({ commit }, text) {
    return new Promise((resolve, reject) => {
      this.$api.get(`/doctor/practice/place?q=${text}`)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getHealthFacilities ({ commit, rootState }, text) {
    return new Promise((resolve, reject) => {
      this.$api.get(rootState.user.auth.role_endpoint + `healthfacilities?q=${text}`)
        .then(function (response) {
          commit('SET_FACILITY_LIST', response.data.Data)
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getCurrentSchedule ({ commit, dispatch, rootState }, data) {
    return new Promise((resolve, reject) => {
      const self = this
      this.$api.get(rootState.user.auth.role_endpoint + 'check/schedule')
        .then(function (response) {
          const res = response.data

          if (res && typeof res !== 'undefined' && res != null && res.Data && res.Data[0]) {
            res.Data[0].RefundAmount100Percent = Math.round(res.Data[0].Price * 100 / 100)
            res.Data[0].RefundAmount90Percent = Math.round(res.Data[0].Price * 90 / 100)

            const remain = res.Data[0].Price - res.Data[0].RefundAmount90Percent

            res.Data[0].DoctorCommission = Math.round(remain * 80 / 100)
            res.Data[0].AdministrationFee = Math.round(remain * 20 / 100)

            commit('SET_CURRENT_SCHEDULE', res.Data[0])
            dispatch('consultation/setScheduleTimer', (res.Data[0].Start - self.$moment().unix()) * 1000, { root: true })
            dispatch('consultation/setExpiredConsultationTimer', (res.Data[0].Start + (rootState.consultation.expiredConsultationTime / 1000) - self.$moment().unix()) * 1000, { root: true })
          } else { commit('SET_CURRENT_SCHEDULE', null) }

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  requestEvent ({ rootState }, data) {
    return new Promise((resolve, reject) => {
      const { body } = data
      const formData = {}
      const url = body.calendarID === '' ? 'schedule/request' : `calendar/${body.calendarID}/invitation`
      const method = body.calendarID === '' ? 'post' : 'put'

      formData.Start = body.start
      formData.End = body.end

      formData.Type = 'ONLINE'
      formData.Price = parseFloat(body.price)
      formData.IsExercise = body.isExercise
      formData.IsAllowTagging = body.isAllowTagging
      formData.ConsultLength = body.consultLength
      formData.FacilityID = body.facilityId

      if (body.recurringTime !== 'not_recurring') {
        formData.Recurring = body.recurring
        formData.RecurringTime = body.recurringTime
      }

      this.$api[method](rootState.user.auth.role_endpoint + url, new URLSearchParams(formData).toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  setEvent ({ rootState }, data) {
    return new Promise((resolve, reject) => {
      const { type, body, isRequest = false } = data
      const formData = {}
      let url = ''
      let method = body.id ? 'put' : 'post'
      let BASE_API = process.env.BASE_API

      formData.Start = body.start
      formData.End = body.end

      if (type === 'Online') {
        url = body.id ? 'calendar/' + body.id + '/online' : 'add/schedule/online'
        if (isRequest) {
          url = 'schedule/request'
        }

        formData.Type = 'ONLINE'
        formData.Price = parseFloat(body.price)
        formData.IsAllowTagging = body.isAllowTagging
        formData.ConsultLength = body.consultLength
        if (body.facilityId) { formData.FacilityID = body.facilityId }
      } else if (type === 'NonOnline') {
        url = body.id ? 'calendar/' + body.id + '/nononline' : 'add/schedule/nononline'
        formData.Type = 'NONONLINE'
        formData.Location = body.location
        formData.Name = body.name
        formData.Phone = body.phone
        formData.Email = body.email
      } else if (type === 'Exercise') {
        url = body.id ? 'calendar/' + body.id + '/online' : 'add/schedule/online'
        formData.Type = 'ONLINE'
        formData.Price = parseFloat(body.price)
        formData.Emails = body.emails
        formData.IsExercise = body.isExercise ? 1 : 0
        formData.ConsultLength = body.consultLength
      } else if (type === 'OnSite') {
        url = body.id ? `calendar/onsite/update/${body.id}` : 'calendar/onsite/create'
        if (isRequest) {
          url = 'calendar/request'
        }

        BASE_API = process.env.BASE_API_V4
        method = 'post'
        formData.Type = 'ONSITE'
        formData.Price = parseFloat(body.price)
        formData.ConsultLength = body.consultLength
        if (body.facilityId) { formData.FacilityID = body.facilityId }
      }

      if (body.recurringTime !== 'not_recurring') {
        formData.Recurring = body.recurring
        formData.RecurringTime = body.recurringTime
      }

      this.$api[method](BASE_API + rootState.user.auth.role_endpoint + url, new URLSearchParams(formData).toString(), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  deleteEvent ({ rootState }, data) {
    return new Promise((resolve, reject) => {
      const { type, id, deleteType } = data

      const payload = {
        CalendarType: type,
        DeleteType: deleteType
      }

      this.$api.post(rootState.user.auth.role_endpoint + `calendar/${id}`, payload)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  deleteManyEvent ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + rootState.user.auth.role_endpoint + 'calendar/delete', payload, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      })
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  invitation ({ rootState }, data) {
    return new Promise((resolve, reject) => {
      const { type, ids } = data

      const payload = {
        IDs: ids
      }

      this.$api.post(rootState.user.auth.role_endpoint + 'invitation/' + type, payload)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  sendTutorialComplete ({ rootState }) {
    return new Promise((resolve, reject) => {
      this.$api.post(rootState.user.auth.role_endpoint + 'tutorial/complete', {})
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },

  getServerTime () {
    return new Promise((resolve, reject) => {
      this.$api.get('doctor/time/server', {})
        .then((response) => {
          if (response.data && response.data.Data) { resolve(response.data.Data.Time) }
        }).catch((error) => {
          reject(error)
        })
    })
  },

  getConsultationPriceList ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      if (state.appointmentPriceList.length) {
        resolve(state.appointmentPriceList)
      } else {
        this.$api.get(data.Type + '/consult/price')
          .then(function (response) {
            const res = response.data.Data
            commit('SET_APPOINTMENT_PRICE_LIST', res)
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      }
    })
  },

  getConsultationLengthList ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      if (state.appointmentLengthList.length) {
        resolve(state.appointmentLengthList)
      } else {
        this.$api.get(data.Type + '/consult/length')
          .then(function (response) {
            const res = response.data.Data
            commit('SET_APPOINTMENT_LENGTH_LIST', res)
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      }
    })
  }
}
